import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import api from '../services/client';
import routes from '../views/routes';
import { decode } from 'jsonwebtoken';
import { getMsalIdToken, setValue, clearStorage } from '../helpers/localStorageHelper';


const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}
let a = 0;

export function AuthProvider({ children }) {
    
    const history = useHistory();
    const [currentUser, setCurrentUser] = useState();
    const [tokenExp, setTokenExp] = useState();
    const [currrentPath, setCurrrentPath] = useState('login');
    const [loading, setLoading] = useState(true);
    const [isAuth, setIsAuth] = useState(false);

    // function signup(email, password) {
    //     return auth.createUserWithEmailAndPassword(email, password);
    // };

    const login = async (data) => {
        return await api.login(data).then(result => {
            const token = result.data.token;
            setValue('authtoken',token);
            return {
                status: 200,
                payload: decode(token, {complete: true}).payload
            } ;
        }).catch(error =>{
            return {
                status : 500,
                message: error?.response?.data?.message ?? error.message + ' Please Contact our support team'
            };
        });
    }

    function updateUser(payload){
        setCurrentUser(payload.result);
        setTokenExp(payload.exp * 1000);
    }

    function logout() {
        setCurrentUser();
        setValue('authtoken','');
        setIsAuth(false);
        history.push(routes.LOGIN_PAGE);
    }

    function setPath(path) {
        setCurrrentPath(path);
    }

    // function resetPassword(email) {
    //     return auth.sendPasswordResetEmail(email);
    // }

    // function updatePassword(password) {
    //     return currentUser.updatePassword(password);        
    // }

    // useEffect(() => {
    //    const unsubscribe =  auth.onAuthStateChanged(user => {
    //         setCurrentUser(user);
    //         setLoading(false);
    //     });

    //     return unsubscribe;
    // }, []);

    useEffect(async ()=>{
        //setLoading(false);
        const unsubscribe = (() => {
            const token = getMsalIdToken();
            let c = currentUser;
            if(token){
                const decodeValue = decode(token, {complete: true});
                const tokenExpTime = decodeValue.payload.exp * 1000;
                if(tokenExpTime > new Date()) {
                   setCurrentUser(decodeValue.payload.result);
                   setTokenExp(tokenExpTime); 
                }               
            }
           setLoading(false);  
        })();

       return unsubscribe;
     },[])

    

    const value = {
        currentUser,
        tokenExp,
        currrentPath,
        isAuth,
        updateUser,
        login,
        logout,
        setPath
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
            {/* {children} */}
        </AuthContext.Provider>
    )
}